import React, { useEffect, useState } from 'react'
import { Nav, Tab } from 'react-bootstrap';
import SidePanel from '../../Common/SidePanel';
import DashboardHeader from '../../Common/DashboardHeader';
import TitleBar from '../../Common/TitleBar';
import AvailableTasks from './TaskDetails/TaskModuleComponent/AvailableTasks';
import { useDispatch } from 'react-redux';
import DashboardFooter from '../../Common/DashboardFooter';


const Task = () => {
    const [isActive, setIsActive] = useState(true);
    const dispatch = useDispatch();
    const toggleClass = () => {
        setIsActive(!isActive);
    };
    const [active, setActive] = useState({
        first: true,
        second: false,
        third: false,
        fourth: false,
        six: false,
        fifth: false,
        seven: false,
        eigtht: false,
    })
    const handleActive = (type) => {
        let keyArr = Object.keys(active)
        let arr = { ...active }
        keyArr.forEach((curElem) => {
            if (curElem === type) {
                arr[curElem] = true

            } else {
                arr[curElem] = false
            }
        })
        setActive(arr)
    }
    useEffect(() => {
        return () => {
            dispatch({ type: "REMOVE_TASK_LIST" })
        }
    }, [])
    return (
        <>
            <TitleBar title="Tasks" />

            <div className="dashboard Tasker_main_container container-fluid overflow-hidden">
                <div className="row">
                    <div className={`col-lg-2 col-md-3 col-sm-4 col-12 side-nav ${isActive ? "nav-show" : "nav-hide"}`}>
                        <SidePanel />
                    </div>
                    <div className={` p-0 ${isActive ? "col-lg-10 col-md-9 col-sm-8 col-12" : "col-12"} main-content`}>
                        <div className="dashboard-in">
                            <DashboardHeader toggleSidebar={toggleClass} title="Tasks" />
                            <div>
                                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                    <div className="row" >
                                        <div className="col-12">
                                            <Nav variant="pills" style={{ padding: "15px 28px 0px" }} >
                                                <Nav.Item onClick={() => handleActive("first")}>
                                                    <Nav.Link className={active.first ? "active" : ""}> Available Tasks</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item onClick={() => handleActive("second")}>
                                                    <Nav.Link className={active.second ? "active" : ""}>Recommended Tasks</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item onClick={() => handleActive("third")}>
                                                    <Nav.Link className={active.third ? "active" : ""}>Ongoing Tasks</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item onClick={() => handleActive("fourth")}>
                                                    <Nav.Link className={active.fourth ? "active" : ""}>Completed Tasks</Nav.Link>
                                                </Nav.Item >
                                                <Nav.Item onClick={() => handleActive("fifth")}>
                                                    <Nav.Link className={active.fifth ? "active" : ""}>Saved Tasks </Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item onClick={() => handleActive("six")}>
                                                    <Nav.Link className={active.six ? "active" : ""}> Provisional Approved  </Nav.Link>
                                                </Nav.Item >
                                                <Nav.Item onClick={() => handleActive("seven")}>
                                                    <Nav.Link className={active.seven ? "active" : ""}>Approved Tasks </Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item onClick={() => handleActive("eigtht")}>
                                                    <Nav.Link className={active.eigtht ? "active" : ""}>Rejected Tasks </Nav.Link>
                                                </Nav.Item>

                                            </Nav>


                                            <div className="setting_right_side_wrap fix-pad">
                                                <Tab.Content>
                                                    <Tab.Pane className={active.first ? "active show" : ""}>
                                                        <AvailableTasks
                                                            first={active.first}
                                                            type="available"
                                                            url="fetch-avaiable-list"
                                                        />
                                                    </Tab.Pane>
                                                    <Tab.Pane className={active.second ? "active show" : ""}>

                                                        <AvailableTasks
                                                            first={active.second}
                                                            type="recomended"
                                                            url="fetch-recomended-list"
                                                        />
                                                    </Tab.Pane>
                                                    <Tab.Pane className={active.third ? "active show" : ""}>

                                                        <AvailableTasks
                                                            first={active.third}
                                                            type="ongoing"
                                                            url="fetch-ongoing-list"
                                                        />

                                                    </Tab.Pane>
                                                    <Tab.Pane className={active.fourth ? "active show" : ""}>

                                                        <AvailableTasks
                                                            first={active.fourth}
                                                            type="completed"
                                                            url="fetch-completed-list"
                                                        />
                                                    </Tab.Pane>
                                                    <Tab.Pane className={active.fifth ? "active show" : ""}>

                                                        <AvailableTasks
                                                            first={active.fifth}
                                                            type="save"
                                                            url="fetch-bookmark-list"
                                                        />
                                                    </Tab.Pane>
                                                    <Tab.Pane className={active.six ? "active show" : ""}>

                                                        <AvailableTasks
                                                            first={active.six}
                                                            type="provisional"
                                                            url="fetch-provisional-list"
                                                        />
                                                    </Tab.Pane>
                                                    <Tab.Pane className={active.seven ? "active show" : ""}>

                                                        <AvailableTasks
                                                            first={active.seven}
                                                            type="approve"
                                                            url="fetch-approved-list"
                                                        />
                                                    </Tab.Pane>


                                                    <Tab.Pane className={active.eigtht ? "active show" : ""}>

                                                        <AvailableTasks
                                                            first={active.eigtht}
                                                            type="rejected"
                                                            url="fetch-rejected-list"
                                                        />
                                                    </Tab.Pane>



                                                </Tab.Content>
                                            </div>
                                        </div>
                                    </div>
                                </Tab.Container >
                            </div>
                        </div>
                        <DashboardFooter />
                    </div>
                </div >
            </div >

        </>
    )
}

export default Task
